import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const SurveyComplete = () => {
  const { surveyUserForm } = useSelector(state => state.surveyUserForm);
  return (
    <Container>
      <Alert variant="success mt-5">
        {
          surveyUserForm?.finalMessage ? (
            <p>{surveyUserForm?.finalMessage}</p>
          ): (
            <>
              <h4>¡Gracias por completar la encuesta!</h4>
              <p>En breve nos pondremos en contacto contigo</p>
            </>
          )
        }
      </Alert>
    </Container>
  )
}

export default SurveyComplete;